<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		class="svg-icon"
		style="width: 1em; height: 1em; vertical-align: middle; fill: currentColor; overflow: hidden"
		viewBox="0 0 1024 1024"
		version="1.1"
	>
		<path
			d="M504.571429 603.428571q0 7.428571-5.714286 13.142858l-189.714286 189.714285 82.285714 82.285715q10.857143 10.857143 10.857143 25.714285t-10.857143 25.714286-25.714285 10.857143H109.714286q-14.857143 0-25.714286-10.857143t-10.857143-25.714286v-256q0-14.857143 10.857143-25.714285t25.714286-10.857143 25.714285 10.857143l82.285715 82.285714 189.714285-189.714286q5.714286-5.714286 13.142858-5.714286t13.142857 5.714286l65.142857 65.142857q5.714286 5.714286 5.714286 13.142857z m446.285714-493.714285v256q0 14.857143-10.857143 25.714285t-25.714286 10.857143-25.714285-10.857143l-82.285715-82.285714-189.714285 189.714286q-5.714286 5.714286-13.142858 5.714286t-13.142857-5.714286L525.142857 433.714286q-5.714286-5.714286-5.714286-13.142857t5.714286-13.142858l189.714286-189.714285-82.285714-82.285715q-10.857143-10.857143-10.857143-25.714285t10.857143-25.714286 25.714285-10.857143h256q14.857143 0 25.714286 10.857143t10.857143 25.714286z"
		/>
	</svg>
</template>

<script>
export default {
	name: 'ExpandSvg',
};
</script>
